import { Box } from "@mui/material";

const PageDivider = () => {
  return <Box sx={{ mx: 2, width: 2, bgcolor: "text.primary" }}></Box>;
};

export default PageDivider;
